const routes = {
  home: {
    name: 'Home',
    link: '/',
  },
  favorites: {
    name: 'Favorite Players',
    link: '/favorite-players',
  },
  players: {
    name: 'Available Players',
    link: '/available-players',
  },
  faq: {
    name: 'FAQ',
    link: '/faq',
  },
  sampleProfile: {
    name: 'Sample Profile',
    link: '/sample-profile',
  },
  aboutUs: {
    name: 'About Us',
    link: '/about-us',
  },
  summerTrips: {
    name: 'College Summer Trips',
    link: '/college-summer-trips',
  },
  createPlayer: {
    name: 'Create Player',
    link: '/create-player',
  },
  login: {
    name: 'Login',
    link: '/login',
  },
  logout: {
    name: 'Logout',
    link: '/login',
  },
  finishProfile: {
    name: 'finishProfile',
    link: '/finish-profile',
  },
  createAccount: {
    name: 'Create Account',
    link: '/create-account',
  },
  recommendations: {
    name: 'Recommended',
    link: '/recommendations',
  },
  compare: {
    name: 'Compare Players',
    link: '/compare',
  },
  adminDashboard: {
    name: 'Dashboard',
    link: '/admin/dashboard',
  },
  adminActivity: {
    name: 'Activity',
    link: '/admin/activity',
  },
  coachInsights: {
    name: 'Coach Insights',
    link: '/admin/coaches/:coachEmail',
  },
  coachEngagement: {
    name: 'Coach Engagement',
    link: '/admin/coach-engagement',
  },
  editPlayer: {
    name: 'Edit Player',
    link: '/edit/:id',
  },
  resetPassword: {
    name: 'Reset password',
    link: '/reset-password',
  },
  messages: {
    name: 'Messages',
    link: '/messages',
  },
  playerLogin: {
    name: 'Player Login',
    link: '/player-login',
  },
  playerInbox: {
    name: 'Player Inbox',
    link: '/player/inbox',
  },
  playerChecklist: {
    name: 'My Checklist',
    link: '/player/checklist',
  },
  adminChecklistTemplate: {
    name: 'Checklist Template',
    link: '/admin/checklist-template',
  },
  adminChecklistProgress: {
    name: 'Checklist Progress',
    link: '/admin/checklist-progress',
  },
  assistantSetup: {
    name: 'Assistant Setup',
    link: '/assistant-setup',
  },
  assistantDashboard: {
    name: 'Moje zadania',
    link: '/admin/assistant-dashboard',
  },
  assistantTimeTracking: {
    name: 'Czas pracy',
    link: '/admin/time-tracking',
  },
  adminAssistants: {
    name: 'Asystenci',
    link: '/admin/assistants',
  },
  adminOpsDashboard: {
    name: 'Dashboard Ops',
    link: '/admin/ops-dashboard',
  },
  adminTimeEntries: {
    name: 'Wpisy czasu',
    link: '/admin/time-entries',
  },
  assistantProfile: {
    name: 'Profil asystenta',
    link: '/admin/assistants/:email',
  },
  assistantMyPlayers: {
    name: 'Moi zawodnicy',
    link: '/admin/my-players',
  },
  assistantPlayerProfile: {
    name: 'Profil zawodnika',
    link: '/admin/my-players/:id',
  },
  adminDocuments: {
    name: 'Dokumenty',
    link: '/admin/documents',
  },
  adminPipeline: {
    name: 'Pipeline',
    link: '/admin/pipeline',
  },
  adminPageContent: {
    name: 'Przewodnik gracza',
    link: '/admin/page-content',
  },
  playerInfo: {
    name: 'Przewodnik',
    link: '/player/info',
  },
  adminCoachMessages: {
    name: 'Coach Messages',
    link: '/admin/coach-messages',
  },
  adminOversightCoach: {
    name: 'Konwersacje trenerów',
    link: '/admin/oversight/coach',
  },
  adminOversightAssistant: {
    name: 'Konwersacje asystentów',
    link: '/admin/oversight/assistant',
  },
  adminPendingCoaches: {
    name: 'Pending Coaches',
    link: '/admin/pending-coaches',
  },
  adminErrorLogs: {
    name: 'Error Logs',
    link: '/admin/error-logs',
  },
};

export default routes;
